import { Api } from 'utils';

class BankAccountService {
	
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/bank-accounts/get',params),
		save: async (params?: any) => Api.createResponse('admin/bank-accounts/save',params),
	}

}

export default BankAccountService;